
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1i0s3_1cn94_93",
  "header": "awsui_header_1i0s3_1cn94_106",
  "full-page": "awsui_full-page_1i0s3_1cn94_106",
  "content": "awsui_content_1i0s3_1cn94_110",
  "error": "awsui_error_1i0s3_1cn94_114",
  "footer": "awsui_footer_1i0s3_1cn94_118",
  "actions-section": "awsui_actions-section_1i0s3_1cn94_122",
  "secondary-actions": "awsui_secondary-actions_1i0s3_1cn94_131",
  "actions": "awsui_actions_1i0s3_1cn94_122"
};
  